import request, { METHODS } from "src/utils/api-base";

const customerApis = {
  // Create or get existing
  createCustomer: (payload: any) => {
    return request({
      route: "/app/customers/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  // List customers by tenant
  getCustomersList: (params: {
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    return request({
      route: "/app/customers/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Get single customer
  getCustomerById: (id: string) => {
    return request({
      route: `/app/customers/${id}`,
      method: METHODS.GET,
      auth: true,
    });
  },
};

export default customerApis;
